/**
 * Created by fers on 22/11/16.
 */

import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import {LoadingLine} from '../../loadingLine/renderLoadingPanel.react';

import {FormattedMessage, injectIntl, defineMessages, IntlShape} from 'react-intl';
import ChannelIcon from '../../channel-defs/ChannelIcon.react';
import LoadingButton from '../../fw/LoadingButton.react';
import {convertFromBoxesToView} from './convertFromBoxesToView';
import {AllowedScreenDisplayer} from './DragAndDrop.react.js';
import EventTracker from '../../app/EventTracker';
import BoxesToAdd from './BoxesToAdd.react';
import DataSourcesToAdd from './DataSourcesToAdd.react';
import DataSourcesToEdit from './DataSourcesToEdit.react';
import DataSourceInfo from './DataSourceInfo.react';
import './DataSourceList.scss';
import { getEditDataSourceFragment } from './../box-utils/ScreenDisplayer.react';
import {assert} from 'chai';
import {hasUIHandlerConfig} from '../datasource-handlers/handlers';

const messages = defineMessages({
	buildQuery: {id: 'screenSettings.buildQuery', 'defaultMessage': 'Extend queried data'},
	configQuery: {id: 'screenSettings.configQuery', 'defaultMessage': 'Configure data source'},
	infoQuery: {id: 'screenSettings.infoQuery', 'defaultMessage': 'Information about data source'},
	reduceQuery: {id: 'screenSettings.reduceQuery', 'defaultMessage': 'Remove data source'}
});

defineMessages({
	"fullcontact_name": {id: 'dataSource.fullcontact.name', 'defaultMessage': 'FullContact social networks search'},
	"fullcontact_description": {id: 'dataSource.fullcontact.description', 'defaultMessage': 'Search by email/domain in social networks using FullContact.'},
	"companies-match_name": {id: 'dataSource.companies-match.name', 'defaultMessage': 'Match company in other apps'},
	"companies-match_description": {id: 'dataSource.companies-match.description', 'defaultMessage': 'Find companies with same/similar name in your other apps.'},
	"fullcontact-company-email_name": {id: 'dataSource.fullcontact-company-email.name', 'defaultMessage': 'FullContact social media search'},
	"fullcontact-company-email_description": {id: 'dataSource.fullcontact-company-email.description', 'defaultMessage': 'Search email/domain in social networks using FullContact.'},
	"contact-match_name": {id: 'dataSource.contact-match.name', 'defaultMessage': 'Match contact in other systems'},
	"contact-match_description": {id: 'dataSource.contact-match.description', 'defaultMessage': 'Find contacts with same/similar name.'},
	"fullcontact-contact-email_name": {id: 'dataSource.fullcontact-contact-email.name', 'defaultMessage': 'FullContact social media search'},
	"fullcontact-contact-email_description": {id: 'dataSource.fullcontact-contact-email.description', 'defaultMessage': 'Search email/domain in social networks using FullContact.'},
	"company-merk_name": {id: 'dataSource.company-merk.name', 'defaultMessage': 'Use Merk search'},
	"company-merk_description": {id: 'dataSource.company-merk.description', 'defaultMessage': 'Search company by name in Merk database.'},
	"company-merk-relation_name": {id: 'dataSource.company-merk-relation.name', 'defaultMessage': 'Merk connected companies'},
	"company-merk-relation_description": {id: 'dataSource.company-merk-relation.description', 'defaultMessage': 'Find connected companies in Merk database (mother/daugther/owner/director/...).'},
	"company-firmo_name": {id: 'dataSource.company-firmo.name', 'defaultMessage': 'Use Firmo search'},
	"company-firmo_description": {id: 'dataSource.company-firmo.description', 'defaultMessage': 'Search company by name in Firmo database.'},
	"default-query_name": {id: 'dataSource.default-query.name', 'defaultMessage': '{entityDefName} in {channelDefName}'},
	"default-query_description": {id: 'dataSource.default-query.description', 'defaultMessage': 'Active when you open {entityDefName} in {channelDefName}'},
	"relation_name": {id: 'dataSource.relation.name', 'defaultMessage': 'Find data in relation type {entityDefName}'},
	"relation_description": {id: 'dataSource.relation.description', 'defaultMessage': 'Find data in relation between {parentEntityDefName} and {entityDefName}.'},
	"query_name": {id: 'dataSource.query.name', 'defaultMessage': 'Query data in application'},
	"query_description": {id: 'dataSource.query.description', 'defaultMessage': 'Make a generic query.'},
	"manual-query_name": {id: 'dataSource.manual-query.name', 'defaultMessage': 'Manually create DatiQuery'},
	"manual-query_description": {id: 'dataSource.manual-query.description', 'defaultMessage': 'Make a query by manually created DatiQuery'},
	"search-action_name": {id: 'dataSource.search-action.name', 'defaultMessage': 'Perform search action'},
	"search-action_description": {id: 'dataSource.search-action.description', 'defaultMessage': 'Ask remote service for search.'},
	"company-search_name": {id: 'dataSource.company-search.name', 'defaultMessage': 'Company search'},
	"company-search_description": {id: 'dataSource.company-search.description', 'defaultMessage': 'Search company in other applications.'},
	"contact-search_name": {id: 'dataSource.contact-search.name', 'defaultMessage': 'Search contacts'},
	"contact-search_description": {id: 'dataSource.contact-search.description', 'defaultMessage': 'Search contacts in other applications.'},

});

export function getMessageArgsForDataSource(dataSource, parentDataSource) {
	assert.isDefined(dataSource);
	let messageArgs = {};

	if (dataSource.entityDefs && dataSource.entityDefs.length > 0) {
		messageArgs['entityDefName'] = dataSource.entityDefs.map((ed) => ed.name).join(", ");
	} else {
		messageArgs['entityDefName'] = "<?>";
	}

	if (dataSource.channelDefs && dataSource.channelDefs.length > 0) {
		messageArgs['channelDefName'] = dataSource.channelDefs.map((ed) => ed.name).join(", ");
	} else {
		messageArgs['channelDefName'] = "<?>";
	}

	if (parentDataSource && parentDataSource.entityDefs && parentDataSource.entityDefs.length > 0) {
		messageArgs['parentEntityDefName'] = parentDataSource.entityDefs.map((ed) => ed.name).join(", ");
	} else {
		messageArgs['parentEntityDefName'] = "<?>";
	}

	if (parentDataSource && parentDataSource.channelDefs && parentDataSource.channelDefs.length > 0) {
		messageArgs['parentChannelDefName'] = parentDataSource.channelDefs.map((ed) => ed.name).join(", ");
	} else {
		messageArgs['parentChannelDefName'] = "<?>";
	}

	return messageArgs;
}

export function getDataSourceName(intl, dataSources, dataSource) {
	let parentIdx = -1;
	let parentDataSource = null;
	if (dataSource.relativeTo) {
		parentIdx = dataSources.findIndex((dataSource2) => dataSource2['realId'] === dataSource.relativeTo['realId']);
		if (parentIdx !== -1) {
			parentDataSource = dataSources[parentIdx];
		}
	}

	let title = "";
	let description = "";

	let messageArgs = getMessageArgsForDataSource(dataSource, parentDataSource);

	if (dataSource.description) {
		description += dataSource.description;
	} else {
		description += intl.formatMessage({
			id: 'dataSource.' + dataSource.typeId + '.description',
		}, messageArgs);
	}

	if (dataSource.name) {
		title += dataSource.name;
	} else {
		title += intl.formatMessage({
			id: 'dataSource.' + dataSource.typeId + '.name',
		}, messageArgs);
	}

	return {
		parentIdx: parentIdx,
		title: title,
		description: description
	};
}

class DataSourceList extends React.Component {
	static propTypes = {
		canModify: PropTypes.bool,
		intl: PropTypes.object,
		relay: PropTypes.object.isRequired,
		screen: PropTypes.object.isRequired,
		screenSettings: PropTypes.object.isRequired,
		user: PropTypes.object.isRequired,
	};

	constructor(props) {
		super(props);

		this.state = {
			selectedDataSourceToAdd: null,
			selectedDataSourceToEdit: null,
			selectedDataSourceInfo: null,
			selectedDataSourceIdx: null,
			selectedDataSource: [],
			selectedDataSourceLast: null,
		};
	}

	showBoxesToAdd(screen, dataSource, entityDef) {
		if (!dataSource) {
			return;
		}

		return (
			<AllowedScreenDisplayer
				asList
				canModify={this.props.canModify}
				isPreview
				screen={screen}
				screenSettings={this.props.screenSettings}
				viewsWithData={dataSource.boxesToAdd ? dataSource.boxesToAdd.map((node) => {
					return convertFromBoxesToView(node, screen, dataSource, entityDef);
				}) : []}
			/>
		);
	}

	onClickDataSource = (dataSourceId, idx) => {
		EventTracker.trackEvent(EventTracker.EVENT_CLICKS, {
			event: 'screen-settings-toggle-open',
			screen: this.props.screen['realId'],
			type: 'embed'
		});

		this.setState({
			selectedDataSource: [dataSourceId]
		});
	};

	onClickToggleDataSource = (dataSourceId, idx) => {
		if (this.state.selectedDataSource.includes(dataSourceId)) {
			EventTracker.trackEvent(EventTracker.EVENT_CLICKS, {
				event: 'screen-settings-toggle-close',
				screen: this.props.screen['realId'],
				type: 'embed'
			});

			this.setState({
				selectedDataSource: this.state.selectedDataSource.filter((item) => {
					return item !== dataSourceId;
				}),
				selectedDataSourceLast: null
			});

		}
		else {
			EventTracker.trackEvent(EventTracker.EVENT_CLICKS, {
				event: 'screen-settings-toggle-open',
				screen: this.props.screen['realId'],
				type: 'embed'
			});

			this.setState({
				selectedDataSource: this.state.selectedDataSource.concat([dataSourceId]),
				selectedDataSourceLast: dataSourceId
			});
		}
	};

	onClickDataSourceConfig = (dataSource, event) => {
		EventTracker.trackEvent(EventTracker.EVENT_CLICKS, {
			event: 'screen-settings-data-source-config',
			screen: this.props.screen['realId'],
			type: 'embed'
		});

		event.preventDefault();
		event.stopPropagation();

		this.props.relay.setVariables({
			dataSourceSelected: true,
			dataSourceId: dataSource.id
		});

		this.setState({
			selectedDataSourceToEdit: dataSource,
		});
	};

	onClickDataSourceToAdd = (dataSourceId, idx) => {
		EventTracker.trackEvent(EventTracker.EVENT_CLICKS, {
			event: 'screen-settings-toggle-open-data-source',
			screen: this.props.screen['realId'],
			type: 'embed'
		});

		this.props.relay.setVariables({
			dataSourceSelected: true,
			dataSourceId: dataSourceId
		});

		this.setState({
			selectedDataSourceToAdd: dataSourceId,
			selectedDataSourceIdx: idx
		});
	};

	onClickDataSourceInfo = (dataSourceId, idx) => {
		EventTracker.trackEvent(EventTracker.EVENT_CLICKS, {
			event: 'screen-settings-toggle-info-data-source',
			screen: this.props.screen['realId'],
			type: 'embed'
		});

		this.props.relay.setVariables({
			dataSourceSelected: true,
			dataSourceId: dataSourceId
		});

		this.setState({
			selectedDataSourceInfo: dataSourceId,
			selectedDataSourceIdx: idx
		});
	};

	onClickDataSourceToRemove = (dataSource, event, fromDetail) => {
		EventTracker.trackEvent(EventTracker.EVENT_CLICKS, {
			event: 'screen-settings-data-source-reduce',
			screen: this.props.screen['realId'],
			type: 'embed'
		});

		event.preventDefault();
		event.stopPropagation();

		return new Promise((resolve) => {
			this.props.screenSettings.onClickRemoveDataSource(dataSource, this.props.screen.dataSources, () => {
				if (fromDetail) {
					this.goBack();
				}
				resolve();
			});
		});
	};

	goBack = () => {
		this.props.relay.setVariables({
			dataSourceSelected: false,
			dataSourceId: null
		});

		this.setState({
			selectedDataSource: [],
			selectedDataSourceToAdd: null,
			selectedDataSourceToEdit: null,
			selectedDataSourceInfo: null,
			selectedDataSourceIdx: null,
			selectedDataSourceLast: null
		});
	};

	renderBoxesToAdd(dataSourceId, idx) {
		if (dataSourceId || this.props.screen.dataSources.length === 1) {
			let dataSources = this.props.screen.dataSources;
			let dataSource;

			try {
				if (this.props.screenSettings.props.user.organisation.channel.screen.dataSources) {
					dataSources = this.props.screenSettings.props.user.organisation.channel.screen.dataSources;
				}
			} catch (e) {}

			if (dataSources.length === 1) {
				dataSource = dataSources[0];
			} else {
				dataSource = dataSources.find((ds) => ds['realId'] === dataSourceId);
			}

			if (dataSource.boxesToAdd.length === 0) {
				this.setState({
					selectedDataSourceToAdd: dataSource['realId'],
					selectedDataSourceIdx: 0
				});
			}

			return (
				<BoxesToAdd
							canModify={this.props.canModify}
							dataSource={dataSource}
							dataSourceList={this}
							hasManyDataSources={dataSources.length > 1}
							idx={idx}
							screen={this.props.screen}
							screenSettings={this.props.screenSettings}
				/>
			);
		}
	}

	isDataSourceExpanded(dataSource) {
		return this.state.selectedDataSource.includes(dataSource['realId']);
	}

	scrollTo(el) {
		if (el) {
			el.offsetParent.scrollTop = el.offsetTop;

			this.setState({
				selectedDataSourceLast: null
			});
		}
	}

	hasDataSourceConfigAtAll(dataSources, userPermissions) {
		return dataSources.some((dataSource) => {
			return hasUIHandlerConfig(dataSource.typeId, userPermissions);
		});
	}

	renderDataSource(dataSource, idx) {
		let screen = this.props.screen;

		let {parentIdx, title, description} = getDataSourceName(this.props.intl, screen.dataSources, dataSource);

		let hasBoxesToAdd = false;
		if (dataSource.boxesToAdd && dataSource.boxesToAdd.length) {
			hasBoxesToAdd = true;
		}

		// if (dataSource.entityDefs && dataSource.entityDefs.length > 0) {
			let parent;
			if (parentIdx !== -1) {
				parent = screen.dataSources[parentIdx];

				if (parent.idx) {
					//display stored idx not order from datasources
					parentIdx = parent.idx;
				}
				else {
					parentIdx += 1;
				}
			}

			let isValid = true;

			if ('checkValidity' in dataSource) {
				isValid = dataSource.checkValidity;
			}

			let logos;
			if (dataSource.type === 'company-search') {
				logos = (<ChannelIcon channelDef={{icon: 'companySearchLogo'}} size={32} />);
			}
			else if (dataSource.channelDefs && dataSource.channelDefs.length > 0) {
				logos = dataSource.channelDefs.map((channelDef, idx) => {
					return channelDef.icon ? (<ChannelIcon channelDef={channelDef} key={idx} size={32} />) : null;
				});
			}
			else {
				logos = <ChannelIcon channelDef={{icon: 'dativery'}} size={32} />;
			}

			// don't show colummn for config buttons if no data source has config action
			let someDataSourceHasConfig = this.hasDataSourceConfigAtAll(this.props.screen.dataSources, this.props.user.globalPermissions);

			return (
				<div className={"dataSource-box" + (hasBoxesToAdd ? '' : ' noBoxesToAdd') + (this.isDataSourceExpanded(dataSource) ? ' expnaded' : '') + (!isValid ? ' dataSource-invalid' : '')} key={idx} ref={(el) => { this.state.selectedDataSourceLast === dataSource['realId'] ? this.scrollTo(el) : null;}}>
					<div className="dataSource-item" onClick={hasBoxesToAdd ? () => this.onClickToggleDataSource(dataSource['realId'], idx) : null }>
						<div className="dataSource-idx-box"><span className="dataSource-idx" title={description}>#{dataSource.idx || idx + 1}</span></div>
						<div className="dataSource-title-icon">
							{logos}
						</div>
						<div className="dataSource-title-box">

							<strong title={dataSource.entityDefs && dataSource.entityDefs.length > 0 ? dataSource.entityDefs.map((ed) => ed.name).join(", ") : null}>{title}</strong>
							{parent ?
								<span className="dataSource-relativeTo-description"><FormattedMessage defaultMessage="Uses data from" id="screenSettings.dependsOn" />{" "}
									<span className="dataSource-idx" title={parent.name ? parent.name : (parent.entityDefs && parent.entityDefs.length > 0 ? parent.entityDefs.map((ed) => ed.name).join(", ") : null)}>#{parentIdx}</span>
								</span>
							: null}
							{!isValid ? <span className="dataSource-relativeTo-missingApplication"><FormattedMessage defaultMessage="References deleted application, obsolete action or is invalid." id="screenSettings.missingApplicationOrInvalid" />{" "}</span> : null}
							<br/>
							{description ? <small>{description}</small> : null}
						</div>
						<div className="dataSource-detail-box dataSource-plus-box">
							<div className="btn btn-inline"><span className="fa fa-chevron-up" /></div>
						</div>
						<div className="dataSource-plus-box">
							{this.props.canModify ? <div className="btn btn-inline" onClick={() => this.onClickDataSourceToAdd(dataSource['realId'], idx) } title={this.props.intl.formatMessage(messages.buildQuery)}><span className="fa fa-plus" /></div> : null}
						</div>
						{hasUIHandlerConfig(dataSource.typeId, this.props.user.globalPermissions) && this.props.canModify ?
							<div className="dataSource-plus-box">
								<div className="btn btn-inline" onClick={(event) => this.onClickDataSourceConfig(dataSource, event)} title={this.props.intl.formatMessage(messages.configQuery)}><span className="fa fa-cog" /></div>
							</div>
							: someDataSourceHasConfig ? <div className="dataSource-plus-box"></div> : null}
						{this.props.canModify && dataSource.type !== 'default-query' ?
							<div className="dataSource-plus-box">
								<LoadingButton className="btn btn-inline" onClick={(event) => this.onClickDataSourceToRemove(dataSource, event)} title={this.props.intl.formatMessage(messages.reduceQuery)}><span className="fa fa-times" /></LoadingButton>
							</div>
							: <div className="dataSource-plus-box"></div>}

						{this.isDataSourceExpanded(dataSource) ? <div className="dataSource-hidden-info">
								<div className="btn btn-inline" onClick={() => this.onClickDataSourceInfo(dataSource['realId'], idx) } title={this.props.intl.formatMessage(messages.infoQuery)}><span className="fa fa-info" /></div>
							</div> : null}

					</div>
					{ this.isDataSourceExpanded(dataSource) ? this.renderBoxesToAdd(dataSource['realId'], idx) : null }
				</div>
				);
		// } else {
		//     return (
		//         <div className="dataSource-head" key={idx}><span className="dataSource-idx" title={description}>#{dataSource.idx || idx + 1}</span> {title}
		//         </div>
		//     );
		// }
	}

	render() {
		if (this.state.selectedDataSourceToAdd) {
			let dataSource = this.props.screen.dataSource;

			if (dataSource) {
				return (
					<DataSourcesToAdd   dataSource={dataSource}
                                        dataSourceList={this}
                                        dataSourcesCnt={this.props.screen.dataSources.length}
                                        idx={this.state.selectedDataSourceIdx}
                                        screen={this.props.screen}
                                        screenSettings={this.props.screenSettings}
					/>
				);
			} else {
				return <LoadingLine />;
			}
		} else if (this.state.selectedDataSourceInfo) {
			let dataSource = this.props.screen.dataSource;

				if (dataSource) {
					return (
						<DataSourceInfo dataSource={dataSource}
										dataSourceList={this}
										idx={this.state.selectedDataSourceIdx}
										screen={this.props.screen}
										screenSettings={this.props.screenSettings}
						/>
					);
				} else {
					return <LoadingLine />;
				}
		} else if (this.state.selectedDataSourceToEdit) {
			let dataSource = this.props.screen.dataSource;

			if (dataSource) {
				return (
					<DataSourcesToEdit  dataSource={dataSource}
										dataSourceList={this}
										screen={this.props.screen}
										screenSettings={this.props.screenSettings}
					/>
				);
			} else {
				return <LoadingLine />;
			}
		}


		return (
			<div className="dataSource-list">
				{this.props.screen.dataSources.sort((a, b) => { return parseInt(a.idx, 10) > parseInt(b.idx, 10) ? 1 : (parseInt(a.idx, 10) < parseInt(b.idx, 10) ? -1 : 0); }).map((dataSource, idx) => {
					return (
						this.renderDataSource(dataSource, idx)
					);
				})}
			</div>
		);
	}
}

export function getDataSourcesToAddFragment() {
	return Relay.QL`
		fragment on DataSource {
			dataSourcesToAdd {
				id,
				realId,
				type,
				typeId,
				group,
				uiAddHandler,
				name,
				description,
				icon,
				entityDef_id,
				relativeTo_id,
				channelDef_id,
				channelDef {
					id,
					name,
					icon
				},
				helperEntityDef_id,
				helperChannel_id,
				helperChannelDef_id,
			}
		}
	`;
}

export default Relay.createContainer(injectIntl(DataSourceList), {
	initialVariables: {
		dataSourceId: '',
		dataSourceSelected: false,
	},
	prepareVariables (variables) {
		return variables;
	},
	fragments: {
		screen: () => Relay.QL`
			fragment on Screen {
				id,
				organisation {
					id,
					realId,
				},
				dataSources {
					id,
					realId,
					${getEditDataSourceFragment()},
					helperChannelDefs {
						id,
						name,
						icon
					},
					channelDefKeys
				},
				dataSource(id: $dataSourceId) @include(if: $dataSourceSelected) {
					id,
					${DataSourcesToAdd.getFragment('dataSource')},
					${DataSourcesToEdit.getFragment('dataSource')},
					${DataSourceInfo.getFragment('dataSource')},
					${getDataSourcesToAddFragment()}
				}
			}
		`
	}
});
